import { Performer, HttpMethod } from '../core'
import type { AuthResponse } from './models'

export class Refresh extends Performer<
  { payload: { refreshToken: string; deviceId: string } },
  AuthResponse
> {
  protected method = HttpMethod.POST
  protected url = '/refresh'
}
